import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || 'https://hufapfkyppbqgynltggd.supabase.co';
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imh1ZmFwZmt5cHBicWd5bmx0Z2dkIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjMyOTU2NDEsImV4cCI6MjA3ODg3MTY0MX0.IywppIE1uUT2pkueQuNGtb_-vt_feznZ1tRKqPJcw40';

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    storageKey: 'uncommonable-auth', // Custom storage key to prevent conflicts
  },
});
